// extracted by mini-css-extract-plugin
export var backDrop = "CountryChangeSuggester-module--backDrop--fff28";
export var countrySuggesterSwitch = "CountryChangeSuggester-module--countrySuggesterSwitch--d86fb";